import React from "react";
import Chip from "@mui/material/Chip";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    neutral: {
      main: "#616161",
      contrastText: "#fff",
    },
  },
});

const status = (currentStatus) => {
  
  switch (currentStatus) {
    case "executed":
      return (
        <ThemeProvider theme={theme}>
          <Chip label="Ejecutado" color="success" />
        </ThemeProvider>
      );
    case "unexecuted":
      return (
        <ThemeProvider theme={theme}>
          <Chip label="No Ejecutado" color="neutral" />
        </ThemeProvider>
      );
  }
};

export default function IndicatorStatus(currentStatus) {
  return status(currentStatus.currentStatus);
}
